import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { StrictMode } from "react";
import { Entrata } from "./pages/Entrata/Entrata"
import { Utenti } from "./pages/Utenti/Utenti"
import { Bar } from "./pages/Bar/Bar"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Routes>
            <Route path="/entrata" element={<Entrata />} />
            <Route path="/utenti" element={<Utenti />} />
            <Route path="/bar" element={<Bar />} />
            <Route path="/" element={<App />} />
        </Routes>
    </BrowserRouter>
);
